export const SHOW_CATEGORY_DETAILS = 'SHOW_CATEGORY_DETAILS';
